import React, { useState } from "react";
import { Typography, Icon } from "@mui/material";
import ChapterList from "../../../layouts/profile/components/ChapterList";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MDBox from "components/MDBox";
import EventList from "./EventList";
import CareerComponent from "./CareerComponent";
// import CareerList from "./CareerList";

const features = [
  {
    key: "chapter",
    description: "Explore all chapters and their details.",
    icon: "menu_book",
    iconBg: "#1976d2", // blue
  },
  {
    key: "event",
    description: "See upcoming and past events.",
    icon: "event",
    iconBg: "#43a047", // green
  },
  {
    key: "career",
    description: "Find career opportunities and guidance.",
    icon: "work",
    iconBg: "#f9a825", // yellow
  },
];

const LinktoAnothers = () => {
  const [viewed, setViewed] = useState(null);

  return (   
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox p={2}>
        <MDBox
          sx={{
            p: 2,
            borderRadius: 3,
            boxShadow: 2,
            bgcolor: "transparent",
            maxWidth: "100%",
            width: "100%",
            mx: "auto",
            mb: 3,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {features.map((feature) => (
            <MDBox
              key={feature.key}
              onClick={() => setViewed(feature.key)}
              sx={{
                width: { xs: "100%", sm: "31%", md: "30%" }, // auto-responsive width
                height: 140,
                cursor: "pointer",
                borderRadius: 2,
                bgcolor: viewed === feature.key ? "#e3f2fd" : "#fff",
                boxShadow: viewed === feature.key ? 4 : 1,
                border:
                  viewed === feature.key
                    ? "2px solid #1976d2"
                    : "1px solid #e0e0e0",
                transition: "all 0.2s ease-in-out",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
                py: 1.5,
                textAlign: "center",
                "&:hover": {
                  boxShadow: 6,
                  border: "2px solid #1976d2",
                  bgcolor: "#e3f2fd",
                },
              }}
            >
              <MDBox
                sx={{
                  bgcolor: feature.iconBg,
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 1,
                  mb: 1,
                }}
              >
                <Icon sx={{ color: "#fff", fontSize: 18 }}>{feature.icon}</Icon>
              </MDBox>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  mb: 0.5,
                }}
              >
                {feature.key.charAt(0).toUpperCase() + feature.key.slice(1)}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.7rem" }}
              >
                {feature.description}
              </Typography>
            </MDBox>
          ))}
        </MDBox>

        <MDBox mt={2}>
          {viewed === "chapter" && <ChapterList />}
          {viewed === "event" && <EventList />}
          {viewed === "career" && <CareerComponent />}
          {/* Uncomment the line below if you have a CareerList component */}
          {/* {viewed === "career" && <CareerList />} */}
          {!viewed && (
            <Typography
              variant="body2"
              color="text.secondary"
              align="center"
              sx={{ mt: 2 }}
            >
              Click a view card above to see more details.
            </Typography>
          )}
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
};

export default LinktoAnothers;
